import PropTypes from "prop-types";
import React, { useEffect, useRef } from "react";

import styled from "styled-components/macro";

const CroppedImage = ({
  croppedAreaPixels,
  imageUrl,
  maxWidth,
  className,
  ...rest
}) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (!croppedAreaPixels || !imageUrl || !canvasRef.current) {
      return;
    }

    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const img = new Image();

    img.onload = () => {
      const { x, y, width, height } = croppedAreaPixels;

      let canvasWidth = width;
      let canvasHeight = height;

      // Scale down if needed to respect maxWidth
      if (maxWidth) {
        const maxWidthNum = parseInt(maxWidth);
        if (canvasWidth > maxWidthNum) {
          const scale = maxWidthNum / canvasWidth;
          canvasWidth = maxWidthNum;
          canvasHeight = height * scale;
        }
      }

      canvas.width = canvasWidth;
      canvas.height = canvasHeight;

      ctx.drawImage(img, x, y, width, height, 0, 0, canvasWidth, canvasHeight);
    };

    img.src = imageUrl;
  }, [croppedAreaPixels, imageUrl, maxWidth]);

  if (!croppedAreaPixels || !imageUrl) {
    return null;
  }
  return (
    <CanvasContainer className={className} {...rest}>
      <Canvas ref={canvasRef} />
    </CanvasContainer>
  );
};

export default CroppedImage;

const CanvasContainer = styled.div`
  display: inline-block;
  border-radius: 8px;
  border: 2px solid #ddd;
  overflow: hidden;
  background: #f5f5f5;
`;

const Canvas = styled.canvas`
  display: block;
  max-width: 100%;
  height: auto;
`;

CroppedImage.propTypes = {
  croppedAreaPixels: PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
  }),
  imageUrl: PropTypes.string.isRequired,
  maxWidth: PropTypes.string,
  className: PropTypes.string,
};
